import type { User } from 'firebase/auth';

// Firebase requires an allowlisted continuation domain; ephemeral previews are not allowlisted.
export const verificationActionSettings = { url: 'https://chat.juris.es', handleCodeInApp: false };

// Access follows Firebase's signed claim, never a Firestore profile field or provider name.
export const hasVerifiedEmail = (claims: Record<string, unknown>): boolean => claims.email_verified === true;

export const refreshVerifiedEmail = async (user: Pick<User, 'reload' | 'getIdTokenResult' | 'emailVerified'>): Promise<boolean> => {
  await user.reload();
  if (!user.emailVerified) return false;
  const token = await user.getIdTokenResult(true);
  return hasVerifiedEmail(token.claims);
};
